export const RESOURCES = {
    INTERNAL_USERS: 'internal-users',
    PARTNER_USERS: 'partner-users',
    DEFAULT_CONFIG: 'default-config',
    PARTNER_CONFIG: 'partner-config',
    DEVICES: 'devices',
    PLATFORM_AUDIT_LOGS: 'platform-audit-logs',
    PLATFORM_DEVICES: 'platform-devices',
    PARTNERS: 'partners',
    BULK_UPLOAD_DEVICES: 'bulk-upload-devices',
    BULK_UPLOAD_SIMS: 'bulk-upload-sims',
    CUSTOM_FIELDS: 'custom-fields',
    SIM_PROVIDERS: 'sim-providers'
} as const;